import Menu from 'antd-core/es/menu';
import styled from 'styled-components';

const Root = styled(Menu) `
  &.tend-ui-menu-light.tend-ui-menu-horizontal > .tend-ui-menu-item-selected,
  &.tend-ui-menu-light
    > .tend-ui-menu.tend-ui-menu-horizontal
    > .tend-ui-menu-item-selected,
  &.tend-ui-menu-light.tend-ui-menu-horizontal > .tend-ui-menu-submenu-selected,
  &.tend-ui-menu-light
    > .tend-ui-menu.tend-ui-menu-horizontal
    > .tend-ui-menu-submenu-selected {
    background: ${props => props.$theme.colors.blue100};
  }

  &.tend-ui-menu-horizontal {
    line-height: 1;
    border-bottom: none;
  }

  &.tend-ui-menu-horizontal .tend-ui-menu-item,
  &.tend-ui-menu-horizontal .tend-ui-menu-submenu {
    padding: 8px 12px;
    /* FIXME: remove important */
    border-radius: 8px !important;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export { Root };
//# sourceMappingURL=styled.js.map
